module.exports = __webpack_public_path__ + "media/icons/account@2x-d1f48f8c.png";